
        var result = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/postcss-loader/lib/index.js!./entero-live-deliverycount.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    